export default "__VITE_ASSET__CWKDaNSM__"